export default __webpack_public_path__ + "static/media/CityLights08.1143063e.jpg";